export function getTdmCompleteOverCount(
  data: { status: string; _count: { status: number } }[] | undefined
) {
  let totalCount = 0;
  let completeCount = 0;
  let percentComplete = 0;

  if (data) {
    data.forEach((d) => {
      totalCount += d._count.status;
      if (d.status === "COMPLETE") {
        completeCount += d._count.status;
      }
    });

    percentComplete = parseInt(((completeCount / totalCount) * 100).toFixed(0));
  }

  return { totalCount, completeCount, percentComplete };
}
